export const MENU = {
  HOME: 'home',
  BROADCAST: 'broadcast',
  LIVE: 'live',
  LIVE_NEW: 'live_new',
  MOVIE: 'movie',
  GLOBAL: 'global',
  PLAYY: 'palyy',
  CLIP: 'clip',
  LIST: 'list',
  MOVIE_17: 'movie_17',
  MOVIE_18: 'movie_18',
  BASEBALL: 'baseball',
  CATEGORY: 'category',
  MY: 'my'
}
export const ON_DISPLAY_BAND = 'on_display_multi_band'
export const STORAGE_ROUTER_HISTORY = 'router_history'
export const STORAGE_TRANSACTION_KEY = 'transaction_key'
export const STORAGE_ROUTER_BACK_ADDRESS = 'router_back_address'
export const STORAGE_CONTENT_FROM_SEARCH = 'content_from_search'
